<template>
  <nav class="om-index" :class="{ 'om-index-compact': compact }">
    <section v-for="part in parts" :key="part.title" class="om-part">
      <p v-if="part.title" class="om-part-title">{{ part.title }}</p>
      <router-link
        v-for="chapter in part.chapters"
        :key="chapter.slug"
        class="om-chapter-link"
        :class="{ 'om-chapter-active': chapter.slug === activeSlug, 'om-chapter-changed': isChanged(chapter) }"
        :to="chapterRoute(chapter)"
        @click.native="$emit('navigate')"
      >
        <span class="om-chapter-title">{{ chapter.title }}</span>
        <manual-change-badge :status="chapter.change_status" />
      </router-link>
    </section>
  </nav>
</template>

<script>
import ManualChangeBadge from './ManualChangeBadge.vue';
import { CHANGE_STATUS, MANUAL_ROUTES } from './manualCopy';

export default {
  name: 'ManualChapterList',
  components: { ManualChangeBadge },
  props: {
    manualKey: { type: String, required: true },
    chapters: { type: Array, default: () => [] },
    activeSlug: { type: String, default: '' },
    compact: { type: Boolean, default: false },
  },
  computed: {
    parts() {
      return this.chapters.reduce((parts, chapter) => {
        const last = parts[parts.length - 1];
        if (last && last.title === chapter.part_title) {
          last.chapters.push(chapter);
        } else {
          parts.push({ title: chapter.part_title, chapters: [chapter] });
        }
        return parts;
      }, []);
    },
  },
  methods: {
    isChanged(chapter) {
      return chapter.change_status !== CHANGE_STATUS.unchanged;
    },
    chapterRoute(chapter) {
      return { name: MANUAL_ROUTES.chapter, params: { manualKey: this.manualKey, chapterSlug: chapter.slug } };
    },
  },
};
</script>

<style scoped>
.om-part + .om-part { margin-top: 18px; }
.om-part-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: var(--om-faint); margin: 0 0 6px; }
.om-chapter-link { display: flex; align-items: center; justify-content: space-between; gap: 10px; min-height: 48px; padding: 10px 12px; border-radius: 10px; color: var(--om-ink); text-decoration: none; border: 1px solid transparent; }
.om-chapter-link:hover { background: var(--om-soft); color: var(--om-ink); }
.om-chapter-changed { border-left: 3px solid var(--om-green); }
.om-chapter-active { background: var(--om-green-tint); border-color: rgba(93, 188, 133, .35); font-weight: 650; }
.om-chapter-title { line-height: 1.35; }
.om-index-compact .om-chapter-link { min-height: 40px; padding: 7px 10px; font-size: 14px; }
</style>
